module.exports = __webpack_public_path__ + "img/undTooth16.7acbec7f.png";